import React, { useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import WorkCycleEvaluationForm from 'app/components/WorkCycleEvaluationForm';
import { Table, Drawer, Button, Modal, Icon, Result, message, Typography } from 'antd'
import { useStyles, styles } from './WorkCycleEvaluationScreenStyles';
import WorkCycleEvaluationTableContainer from 'app/containers/WorkCycleEvaluationTableContainer';
import CommunicationQuizContainer from 'app/containers/CommunicationQuizContainer';
import CommunicationForm from 'app/components/CommunicationForm';
// import QuizForm from 'app/components/QuizForm';
import QuizForm from 'app/components/QuizFormWorkCycleEvaluation'
import ApiService from 'app/services/ApiService';
import removeObjectProperties from 'app/utils/RemoveObjectProperties';
import EmployeeCard from 'app/components/EmployeeCard';
import { workCycleEvaluationClear, fetchCommunicationsDispatch } from 'app/actions/WorkCycleActions';
import { responsableQuizClear } from 'app/actions/CommunicationQuizActions';
import { auth, employeeById } from 'app/reducers';

import { useDispatch, useSelector } from 'react-redux';
const { confirm } = Modal;
const ButtonGroup = Button.Group;

export default function WorkCycleEvaluationScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const userData = useSelector(auth);
    const employeeData = useSelector(employeeById);

    const [filter, setFilter] = useState([]);
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [isVisible, setVisible] = useState(false);
    const [isChildrenVisible, setChildrenVisible] = useState(false);
    const [idCommunication, setIdCommunication] = useState();
    const [rowData, setRowData] = useState();
    const [current, setCurrent] = useState(0);
    const [quizQuestionsData, setQuizQuestionsData] = useState();
    const [wasAnswered, setAnswered] = useState(true);
    const [isResultVisible, setResultVisible] = useState(false);
    const [resultQuizData, setResultQuizData] = useState();
    const [finish, setFinish] = useState(false)
    const [visibleConfirm, setVisibleConfirm] = useState(false)
    const [disableCTMultiple, setDisableCTMultiple] = useState(true)
    const [selectedRows, setSelectedRows] = useState([])
    const [visibleEvaluationCTMultiple, setVisibleEvaluationCTMultiple] = useState(false)

    useEffect(() => {
        return () => {
            dispatch(workCycleEvaluationClear());
        }
    }, []);

    const onCancel = () => {
        setVisible(false);
    }
    const onCloseAll = () => {
        setResultVisible(false);
        setVisible(false);
        setChildrenVisible(false);
        dispatch(workCycleEvaluationClear());
        dispatch(fetchCommunicationsDispatch((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany), {
            CommunicationProgramId: (formData.CommunicationProgramId === undefined) ? [] : formData.CommunicationProgramId,
            ColaboradorId: (formData.ColaboradorId === undefined) ? [] : formData.ColaboradorId,
            FrontId: (formData.FrontId === undefined) ? [] : formData.FrontId,
            SubdirectionId: (formData.SubdirectionId === undefined) ? [] : formData.SubdirectionId,
            ContractId: (formData.ContractId === undefined) ? [] : formData.ContractId,
            WorkId: (formData.WorkId === undefined) ? [] : formData.WorkId,
            TestId: (formData.TestId === undefined) ? [] : formData.TestId,
            ExternalEmployee: (formData.ExternalEmployee === undefined) ? '' : formData.ExternalEmployee,
            //sortColumn: column,
            //sortDir: order,
            offset: ((pagination.defaultCurrent - 1) * pagination.pageSize),
            limit: pagination.pageSize
        }));
        setQuizQuestionsData()
        setCurrent(0)
    }
    const onClose = () => {
        Modal.confirm({
            title: '¿Deseas abandonar la prueba?',
            content: 'La prueba se enviará como incompleta.',
            okText: 'Continuar',
            cancelText: 'Salir',
            onCancel() {
                setChildrenVisible(false)
            },
        });
    }
    const next = () => {
        const curr = current + 1;
        setCurrent(curr);
    }

    const prev = () => {
        const curr = current - 1;
        setCurrent(curr);
    }
    const onChange = (current) => {
        setCurrent(current);
    }
    const quizForm = () => {
        // setVisible(false)
        dispatch(responsableQuizClear());
        setChildrenVisible(true)
    }
    const quizDone = (data) => {
        data.forEach(i => {
            i.listAnswers = i.correctListAnswers;
            removeObjectProperties(i, ['correctListAnswers', 'deleted', 'idQuestionType', 'isAnswered', 'isEvaluative', 'questionDescription', 'questionTypeName']);
        })
        setChildrenVisible(false);
        ApiService.setResponsibleQualification((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany), { idCommunication: [idCommunication], questions: data }).then(
            res => {
                setResultQuizData(res);
                setResultVisible(true);
            }, error => {
                message.error('No se pudo completar la solicitud, intente más tarde.', error);
            }
        );
    }

    const confirm = (data) => {

        Modal.confirm({
            title: '¿Está seguro que desea finalizar?',
            content: evaluationAnswered(data),
            okText: 'Si',
            onOk: () => onClickOk(data),
            cancelText: 'No',
            visible: visibleConfirm,
            onCancel: setVisibleConfirm(false)
        });
    }

    const onClickOk = (data) => {

        if (visibleEvaluationCTMultiple && selectedRows.length > 1) {
            data.forEach(i => {
                i.listAnswers = i.correctListAnswers;
                removeObjectProperties(i, ['correctListAnswers', 'deleted', 'idQuestionType', 'isAnswered', 'isEvaluative', 'questionDescription', 'questionTypeName']);
            })
            setChildrenVisible(false);
            ApiService.setResponsibleQualification((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany), { idCommunication: selectedRows.map(x => x.idCommunication), questions: data }).then(
                res => {
                    setResultQuizData(res);
                    setResultVisible(true);
                    setDisableCTMultiple(true);
                    setSelectedRows([]);
                }, error => {
                    message.error('No se pudo completar la solicitud, intente más tarde.', error);
                }
            );
        }
        else {
            quizDone(data)
        }

        setVisibleConfirm(false)

    }

    const evaluationAnswered = (data) => {

        let text = []
        data.forEach(e => {
            let idAnswer = e.correctListAnswers[0].idAnswer
            let res = e.listAnswers.find(x => x.idAnswer == idAnswer)

            var resComplete = <p><strong>{e.questionDescription}</strong>   {res.descriptionAnswer}</p>
            text.push(resComplete)
        })

        return <div>{text.map(x => x)}</div>
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} header='Evaluacion de ciclos de trabajo' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <TextEvents
                            text={'Evaluación de ciclos de trabajos'}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.paper} key='1'>
                    <WorkCycleEvaluationForm
                        userData={userData.User}
                        filter={filter}
                        setFilter={setFilter}
                        pagination={pagination}
                        sorter={sorter}
                        formData={formData}
                        setFormData={setFormData}
                        styles={styles}
                        classes={classes}
                        disableCTMultiple={disableCTMultiple}
                        setVisibleEvaluationCTMultiple={setVisibleEvaluationCTMultiple}
                        selectedRows={selectedRows}
                        setVisible={setVisible}
                        setIdCommunication={setIdCommunication}
                        setRowData={setRowData}

                    />
                    <div style={styles.baseVerticalMargin}>
                        <WorkCycleEvaluationTableContainer
                            setIdCommunication={setIdCommunication}
                            classes={classes}
                            filter={filter}
                            sorter={sorter}
                            setSorter={setSorter}
                            pagination={pagination}
                            setPagination={setPagination}
                            formData={formData}
                            setVisible={setVisible}
                            setRowData={setRowData}
                            userData={userData.User}
                            setDisableCTMultiple={setDisableCTMultiple}
                            setSelectedRows={setSelectedRows}
                            selectedRows={selectedRows}
                        >
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            loading={params.isLoading}
                                            rowKey={item => String(item.idCommunication)}
                                            columns={params.cols}
                                            dataSource={params.communications}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            // scroll={{ x: 400 }}
                                            rowSelection={{
                                                type: 'checkbox',
                                                ...params.rowSelection,
                                            }}
                                            scroll={{ x: 'min-content', y: (height - 395) }}
                                            size={"small"}
                                        />
                                    </div>
                                )
                            }}
                        </WorkCycleEvaluationTableContainer>
                    </div>
                </Paper>
            </div>
            <Drawer
                title="Evaluación de ciclo de trabajo"
                width={'100%'}
                closable={false}
                onClose={() => {
                    setVisible(false)
                    setVisibleEvaluationCTMultiple(false)
                }}
                visible={isVisible}
                destroyOnClose={true}
            >
                <CommunicationForm
                    isWorkCycle={true}
                    data={rowData}
                    classes={classes}
                    employeeData={employeeData}
                    visibleEvaluationCTMultiple={visibleEvaluationCTMultiple}
                // disableCTMultiple={disableCTMultiple}
                // selectedRows={selectedRows}
                />
                <Drawer
                    title={'Aprobando ciclo de trabajo'}
                    width={'100%'}
                    onClose={onClose}
                    visible={isChildrenVisible}
                    closable={true}
                    destroyOnClose={true}
                >
                    <CommunicationQuizContainer idCommunication={idCommunication} isWorkCycle={true} isChildrenVisible={isChildrenVisible}>
                        {(params) => {
                            return (
                                <div>
                                    <QuizForm classes={classes}
                                        quizData={params.responsableQuiz}
                                        setChildrenVisible={setChildrenVisible}
                                        setQuizQuestionsData={setQuizQuestionsData}
                                        quizQuestionsData={quizQuestionsData}
                                        setFinish={setFinish} />
                                    <div style={styles.bottomDrawer}>
                                        <Button type="primary" style={{ marginRight: 8 }} disabled={finish === false} onClick={() => confirm(quizQuestionsData)} >
                                            Finalizar
                                        </Button>
                                    </div>
                                </div>
                            )
                        }}
                    </CommunicationQuizContainer>
                </Drawer>
                <div style={styles.bottomDrawer}>
                    <Button type="danger" ghost style={{ marginRight: 8 }} onClick={() => onCancel()}>
                        Cancelar
                    </Button>
                    <Button onClick={() => quizForm()} type="primary"
                    >
                        Comenzar evaluación
                    </Button>
                </div>
            </Drawer>
            <Drawer
                width={'100%'}
                closable={false}
                onClose={() => onCloseAll()}
                visible={isResultVisible}
                destroyOnClose={true}
            >
                {typeof resultQuizData !== 'undefined' ?
                    <Result
                        icon={
                            resultQuizData.isApproved ?
                                <Icon type="check-circle" theme="twoTone" twoToneColor="#5CBF69" />
                                : <Icon type="close-circle" theme="twoTone" twoToneColor="#ff3333" />

                        }
                        title={'Evaluación finalizada'}
                        subTitle={<EmployeeCard classes={classes} data={rowData} result={resultQuizData.isApproved}></EmployeeCard>}
                        extra={<Button type="primary" onClick={() => onCloseAll()}>Regresar</Button>}
                    />
                    : <div />}
            </Drawer>
        </div>
    )
}
